import {useState} from "react";
import './event-list.scss';
import EventPreview from "../event-preview/event-preview";

function EventList() {

    const [state, setState] = useState(null);

    return (
        <div style={{paddingTop: "56px"}}>
            <div className="event-list-header">
                <h2>BROWSE OUR UPCOMING EVENTS</h2>
            </div>
            <div className="event-list">
                <EventPreview id={1} name={"Dubai Property Show in New Jersey"} description={""} address={"CROWN PLAZA, EDISON, NJ"} date={new Date(2025, 4, 31)} eventCode={"NJMAY2025"}></EventPreview>
            </div>
        </div>
    );
}

export default EventList;